// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__XP0YV","options":"AnswerScale_options__mmHFK","selected":"AnswerScale_selected__3BzAg"};